import BigNumber from 'bignumber.js'
import React, { useContext } from 'react'
import { View, Text } from 'styles/reactnative'
import { useExchangeStore } from '../hooks/trade/exchangeStore'


const DpPrice = ({ groupname, price }) => {
	BigNumber.clone() // new line
	const { EPs } = useExchangeStore()

	const EP = EPs?.find(item => item.groupname === groupname)

	return (
		<View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
			<Text
				style={{
					fontSize: 12,
					marginLeft: 5,
					letterSpacing: -0.2,
				}}>
				{price ?
					BigNumber(
				price ? price : 0
				).toFormat(EP?.dp)
					:
					'-'
				}
			</Text>
		</View>
	)
}

export default React.memo(DpPrice)
